<div class="row g-4 mb-3">
  @if (currentProject && (isOwner || isEditor)) {
    <div class="col-sm-auto">
      <div>
        <button (click)="openModal('invite')" type="button" class="btn btn-success add-btn me-1" [disabled]="current_client.plan === null">
          <i class="ri-add-line align-bottom me-1"></i> Invite New Examinee </button>
        </div>
      </div>
    }
    @if (!currentProject) {
      <div class="col-sm-auto">
        <h1>Assessments</h1>
      </div>
    }
    <div class="col-sm">
      <div class="d-flex justify-content-sm-end">
        <div class="search-box ms-2">
          <input type="text" class="form-control search" placeholder="Search..." [(ngModel)]="searchText" (input)="onSearch()">
          <i class="ri-search-line search-icon"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive table-card mt-3 mb-1">
    <table class="table">
      <thead>
        <tr class="bg-light text-muted">
          <th scope="col" style="width: 50px;">No.</th>
          <th class="sort" listsortable="first_name" (listsort)="onSort($event)">First Name</th>
          <th class="sort" listsortable="last_name" (listsort)="onSort($event)">Last Name</th>
          <th class="sort" listsortable="email" (listsort)="onSort($event)">Email</th>
          <th class="sort" listsortable="email" (listsort)="onSort($event)">Questionnaire</th>
          @if (!currentProject) {
            <th>Project</th>
          }
          <th>Status</th>
          <th>Expiration Date</th>
          @if (isAllow) {
            <th>Action</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td [attr.colspan]="colspan" class="text-center"><app-loading-spinner></app-loading-spinner></td>
          </tr>
        }
        @if (!loading && examinees && examinees.length > 0) {
          @for (examinee of examinees; track examinee) {
            <tr>
              <td>{{ examinee.id }}</td>
              <td>
                <ngb-highlight [result]="examinee.person!.first_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="examinee.person!.last_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="examinee.person!.email" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="examinee.questionnaire!.name" [term]="searchText"></ngb-highlight>
              </td>
              @if (!currentProject) {
                <td>
                  <ngb-highlight [result]="examinee.project?.name" [term]="searchText"></ngb-highlight>
                </td>
              }
              <td>
                <span class="badge bg-{{ getStatusColor(examinee) }}-subtle text-{{ getStatusColor(examinee) }} fs-11">{{ getStatus(examinee) | titlecase }}</span>
              </td>
              <td>{{ examinee.expired_at | date: 'medium' }}</td>
              @if (isAllow) {
                <td>
                  <div class="d-flex gap-2">
                    @if (isAnalyst || isOwner) {
                      <div class="edit">
                        <button class="btn btn-sm btn-info edit-item-btn" ngbTooltip="View Examinee" alt="View Examinee" [routerLink]="'examinee/' + examinee.id" [disabled]="!examinee.completed_at">
                          <i class="ri-eye-line align-middle"></i>
                        </button>
                      </div>
                    }
                    @if (!examinee.answered_at && (isOwner || isEditor)) {
                      <div class="edit">
                        <button (click)="openModal('reinvite', examinee)" class="btn btn-sm btn-success edit-item-btn" ngbTooltip="Resend Invite Examinee" alt="Resend Invite Examinee" [disabled]="examinee.completed_at">
                          <i class="ri-mail-send-line align-middle"></i>
                        </button>
                      </div>
                    }
                    @if (!examinee.started_at && (isOwner || isEditor)) {
                      <div class="remove">
                        <button (click)="openModal('delete', examinee)" class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Remove Examinee" alt="Remove Examinee">
                          <i class="ri-delete-bin-line align-middle"></i>
                        </button>
                      </div>
                    }
                    @if (examinee.started_at && isOwner) {
                      <div class="remove">
                        <button (click)="openModal('delete', examinee)" class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Remove Examinee" alt="Remove Examinee">
                          <i class="ri-delete-bin-line align-middle"></i>
                        </button>
                      </div>
                    }
                  </div>
                </td>
              }
            </tr>
          }
        }
        @if (!loading && examinees && examinees.length === 0) {
          <tr>
            <td [attr.colspan]="colspan" class="text-center">No examinees found.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (!loading && examinees && examinees.length > 0) {
    <div class="row justify-content-md-between align-items-md-center">
      <div class="col col-sm-6">
        <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalExaminees}} entries </div>
      </div>
      <div class="col col-sm-6">
        <div class="text-sm-right float-end listjs-pagination">
          <ngb-pagination [collectionSize]="totalExaminees" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getExaminees()"></ngb-pagination>
        </div>
      </div>
    </div>
  }

  <app-invite-examinee #inviteExamineeModal (examineeChanged)="refreshExaminees()"></app-invite-examinee>

  <ng-template #deleteExamineeModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure You want to delete</h4>
            <h4><span class="fw-semibold text-warning">{{ selectedExaminee.person?.first_name ? selectedExaminee.person?.first_name + ' ' + selectedExaminee.person?.last_name : selectedExaminee.person?.email }} </span>assessment?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteExaminee()" [disabled]="submitted && spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #successModal let-modal>
    <div class="modal-content">
      <div class="modal-body text-center p-5">
        <div class="text-end">
          <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="mt-2">
          @if (success) {
            <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
          }
          @if (!success) {
            <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
          }
          <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
          @if (!success) {
            <p class="text-muted mx-4 mb-0">{{ message }}</p>
          }
        </div>
      </div>
    </div>
  </ng-template>